import emergencyImage from "../../../../common/images/emergency.svg";
import { TableWidget } from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { useDashboardMissingQualifications } from "../../hooks/useDashboardMissingQualifications";
import { JSX } from "react";
import { useNavigate } from "react-router";
import { RouteEnum } from "../../../../common/enums/RouteEnum";

export const DashboardMissingCertificates = (): JSX.Element => {
    const navigate = useNavigate();
    const {
        loading,
        table,
        currentPage,
        onPageChange,
        filterTabs,
        emptyResultText,
    } = useDashboardMissingQualifications();

    if (loading) {
        return <Skeleton height={"30rem"} borderRadius={"1.5rem"} />;
    }

    return (
        <TableWidget
            data={table}
            showResultCount={false}
            totalItemsInTitle={false}
            currentPage={currentPage}
            svgUrl={emergencyImage}
            itemsPerPage={12}
            title={"Missende kwalificaties"}
            onChange={onPageChange}
            lastColumnAlignRight={true}
            filterTabs={filterTabs}
            emptyResultText={emptyResultText}
            link={{
                text: "Alle kwalificaties bekijken",
                onClick: () => {
                    navigate(RouteEnum.QUALIFICATIONS);
                },
            }}
        />
    );
};

//        text: string;
//         onClick: () => void;
//         iconUrl?: string;
